import { Modal } from '@cian/ui-kit';
import * as React from 'react';
import { Content } from './parts/Content';
import { ContentHeader } from './parts/ContentHeader';
import { ContentFooter } from './parts/ContentFooter/ContentFooter';
import { mockSummary } from './mockSummary';
import type { IAiSummaryFooterActions } from './types';

export interface IAiSummaryModalDesktopProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  footerActions: IAiSummaryFooterActions[];
  onCallButtonSlotChange?(newbuildingId: number, slot: HTMLDivElement | null): void;
}

export const AiSummaryModalDesktop = ({
  open,
  onOpenChange,
  footerActions,
  onCallButtonSlotChange,
}: IAiSummaryModalDesktopProps): React.JSX.Element | null => {
  const [activeNewbuildingId, setActiveNewbuildingId] = React.useState(mockSummary.summarization[0].id);
  const activeSummary = mockSummary.summarization.find(item => item.id === activeNewbuildingId);
  const activeFooterActions = footerActions.find(item => item.newbuildingId === activeNewbuildingId);

  if (!activeSummary) {
    return null;
  }

  return (
    <Modal
      onOpenChange={onOpenChange}
      open={open}
      width={640}
      header={
        <ContentHeader
          activeNewbuildingId={activeNewbuildingId}
          items={mockSummary.summarization}
          onSelectNewbuilding={setActiveNewbuildingId}
          title={mockSummary.title}
        />
      }
      title={mockSummary.title}
      body={<Content emptyState={mockSummary.emptyState} summary={activeSummary} />}
      footer={
        <ContentFooter
          actionText={mockSummary.disclaimer.actionText}
          activeNewbuildingId={activeNewbuildingId}
          chat={activeFooterActions?.chat}
          onCallButtonSlotChange={onCallButtonSlotChange}
          subtitle={mockSummary.disclaimer.subtitle}
          title={mockSummary.disclaimer.title}
        />
      }
    />
  );
};
